import { render, staticRenderFns } from "./HistoryLicenseDetail.vue?vue&type=template&id=5c7b60f1&scoped=true"
import script from "./HistoryLicenseDetail.vue?vue&type=script&lang=js"
export * from "./HistoryLicenseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b60f1",
  null
  
)

export default component.exports